import { render, staticRenderFns } from "./OxygenMediaInput.vue?vue&type=template&id=1b88f3ba&"
import script from "./OxygenMediaInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenMediaInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenMediaInput.vue?vue&type=style&index=0&id=1b88f3ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports